import { useState } from 'react'
import {
  Modal,
  Button,
  Typography,
  Flex,
  Space,
  Alert,
} from 'antd'
import { SendOutlined } from '@ant-design/icons'
import { useStore } from 'effector-react'

import { submitSendClientToChat, sendClientToChatFx } from '../../edit/model'
import {
  ReasonAutoComplete,
  commitReason,
} from '../../../../../shared/reasonAutocomplete'
import { WithdrawalEdit } from '../../edit'
import { useUserProfile } from '../../../../../features/user'

const { Text } = Typography

type Props = {
  loading: boolean
  withdrawal: WithdrawalEdit
}

export const MoneyHoneyModal: React.FC<Props> = ({
  loading,
  withdrawal,
}) => {
  const [isVisible, setIsVisible] = useState(false)
  const [reason, setReason] = useState('')
  const [error, setError] = useState('')
  const userProfile = useUserProfile()
  const isSending = useStore(sendClientToChatFx.pending)

  const handleClose = () => {
    setIsVisible(false)
    setReason('')
    setError('')
  }

  const handleSubmit = () => {
    if (!reason.trim()) {
      setError('Reason required')
      return
    }
    if (
      window.confirm(
        'Are you ready? The message will only be sent to the Google Chat chat.',
      )
    ) {
      commitReason('withdrawal-money-honey-reason', reason)
      submitSendClientToChat({
        id: Number(withdrawal.clientId),
        email: withdrawal.client.email,
        name: withdrawal.client.fullName,
        clientUrl: `${window.location.origin}/client/${withdrawal.clientId}`,
        managerEmail:
          userProfile.firstName + ' ' + userProfile.lastName,
      })
      handleClose()
    }
  }

  return (
    <>
      <Button
        size="large"
        className="ms-3"
        color="primary"
        variant="solid"
        style={{ backgroundColor: '#3399ff', borderColor: '#3399ff' }}
        disabled={loading}
        loading={loading}
        onClick={() => setIsVisible(true)}
      >
        💰 Send to MoneyHoney
      </Button>
      <Modal
        open={isVisible}
        onCancel={handleClose}
        title={
          <Flex align="center" gap={8}>
            <span>Send to Money Honey</span>
          </Flex>
        }
        width={560}
        footer={
          <Flex justify="flex-end">
            <Space>
              <Button onClick={handleClose}>Cancel</Button>
              <Button
                type="primary"
                disabled={!reason.trim() || isSending}
                loading={isSending}
                icon={<SendOutlined />}
                onClick={handleSubmit}
              >
                Send
              </Button>
            </Space>
          </Flex>
        }
        styles={{
          body: { padding: '16px 24px' },
          header: { paddingBottom: 12 },
        }}
      >
        {error && (
          <Alert
            message={error}
            type="error"
            style={{ marginBottom: 12 }}
          />
        )}

        <Text
          type="secondary"
          style={{
            fontSize: 11,
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
            display: 'block',
            marginBottom: 10,
          }}
        >
          Reason
        </Text>

        <ReasonAutoComplete
          scope="withdrawal-money-honey-reason"
          multiline
          rows={3}
          placeholder="Enter reason..."
          value={reason}
          onChange={(val) => {
            setReason(val)
            setError('')
          }}
          style={{ fontFamily: 'monospace' }}
        />
      </Modal>
    </>
  )
}
